import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, Menu, Toolbar, UseAfter } from '@tencent/workbench';
import { config, TOOLBAR_ITEMS, MENU_CONFIGS } from './config';
import {
    TransitionChangeSimpleFeature,
} from '@framework/workbench/ui/transition/simple/transition-change-simple/transition-change-simple-feature';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class TransitionChangeSimpleController {
    public constructor(@Loader(TransitionChangeSimpleFeature)
    private loader: IDynamicLoader<TransitionChangeSimpleFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'dropdownContent')
    public getContent(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.getDropDownContent();
    }

    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_EFFECT, 'description')
    public getEffectDesc() {
        return this.feature.getTransitionEffectDesc();
    }

    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_EFFECT, 'shouldDisabled')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_DURATION, 'shouldDisabled')
    public shouldDisable() {
        return true;
    }

    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_DURATION, 'description')
    public getDurationDesc() {
        return this.feature.getTransitionDuration();
    }

    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_EMPTY, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FADE, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PUSH, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_SWITCH, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_CUT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PULL, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_COVER, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_WARP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FLIP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_GALLERY, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PRISM, 'shouldCheck')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FLASH, 'shouldCheck')
    public shouldChangeItemCheck(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;

        if (name) {
            return this.getTransitionTypeFromActionType(name) === this.feature.currentSlideTransitionType;
        }

        return false;
    }

    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_EMPTY, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FADE, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PUSH, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_SWITCH, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_CUT, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PULL, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_COVER, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_WARP, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FLIP, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_GALLERY, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PRISM, 'onClick')
    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FLASH, 'onClick')
    public onClickChangeItem(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        if (!name) return;

        this.feature.handleTransitionChange(this.getTransitionTypeFromActionType(name) as TransitionType);
    }

    @Menu(ActionType.TRANSITION_SIMPLE_MENU_ITEM_APPLY_ALL, 'onClick')
    public handleApplyAll() {
        this.feature.handleApplyAll();
    }


    private getTransitionTypeFromActionType(type: string) {
        return type.split(`${ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE}-`)[1];
    }
}
